import "./IndeterminateProgress.scss";

export function IndeterminateProgress({show=true}) {
    return <div className={`loader ${show ? 'show' : ''}`}>
    <progress className="pure-material-progress-circular"/>
  </div>
}